module.exports = __webpack_public_path__ + "static/media/logo_inverted.2a9d1ef7.svg";